import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const CATEGORIES = ['cafe','restaurant','retail','gym','salon','clinic','hotel','education','event','other'];

export default function BusinessSetup() {
  const navigate = useNavigate();
  const [businesses, setBusinesses] = useState([]);
  const [showForm, setShowForm]     = useState(false);
  const [saving, setSaving]         = useState(false);
  const [error, setError]           = useState('');
  const [form, setForm] = useState({
    name:'', category:'cafe', description:'', address:'', phone:'', email:'',
    modules: { loyalty:true, attendance:true, membership:false, products:false, bookings:false, storefront:false },
    accentColor: '#6366f1', website:'', openingHours:'', lat:'', lng:'',
  });

  useEffect(() => {
    api.get('/business/my').then(r => {
      setBusinesses(r.data.businesses);
      if (r.data.businesses.length === 0) setShowForm(true);
    }).catch(() => navigate('/login'));
  }, [navigate]);

  const f = (k,v) => setForm(p=>({...p,[k]:v}));
  const toggleModule = (k) => setForm(p=>({...p,modules:{...p.modules,[k]:!p.modules[k]}}));

  const save = async () => {
    if (!form.name.trim()) return setError('Business name is required');
    setSaving(true); setError('');
    try {
      const { data } = await api.post('/business', form);
      navigate(`/business/${data.business._id}`);
    } catch(err) {
      setError(err.response?.data?.error || 'Failed to create business');
    }
    setSaving(false);
  };

  const C = {
    bg:'#05080f', surface:'rgba(10,16,28,0.9)', border:'rgba(99,102,241,0.2)',
    text:'#e2e8f0', muted:'#475569', indigo:'#6366f1', green:'#34d399', amber:'#fbbf24',
  };
  const inp = { width:'100%', background:'rgba(255,255,255,0.05)', border:`1px solid ${C.border}`,
    borderRadius:10, padding:'11px 14px', color:C.text, fontSize:13, outline:'none',
    boxSizing:'border-box', fontFamily:'inherit', marginTop:4 };

  return (
    <div style={{minHeight:'100vh',background:C.bg,color:C.text,
      fontFamily:'system-ui,sans-serif',padding:'40px 20px',display:'flex',justifyContent:'center'}}>
      <div style={{width:'min(580px,100%)'}}>
        <div style={{marginBottom:32}}>
          <div style={{fontSize:24,fontWeight:800,color:C.text}}>🏪 Business Mode</div>
          <div style={{fontSize:14,color:C.muted,marginTop:6}}>
            Create loyalty programs, track attendance, and manage memberships via NFC.
          </div>
        </div>

        {/* Existing businesses */}
        {businesses.length > 0 && (
          <div style={{marginBottom:28}}>
            <div style={{fontSize:12,color:C.muted,textTransform:'uppercase',letterSpacing:1.5,marginBottom:12}}>Your Businesses</div>
            {businesses.map(b=>(
              <div key={b._id} onClick={()=>navigate(`/business/${b._id}`)}
                style={{padding:'16px 20px',background:C.surface,border:`1px solid ${C.border}`,
                  borderRadius:14,marginBottom:10,cursor:'pointer',
                  display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div>
                  <div style={{fontWeight:700,color:C.text,fontSize:15}}>{b.name}</div>
                  <div style={{fontSize:12,color:C.muted,marginTop:2}}>{b.category} · {b.address||'No address'}</div>
                </div>
                <span style={{color:C.indigo,fontSize:20}}>→</span>
              </div>
            ))}
            <button onClick={()=>setShowForm(true)}
              style={{marginTop:8,padding:'9px 18px',borderRadius:10,
                border:`1px solid ${C.border}`,background:'transparent',
                color:C.muted,cursor:'pointer',fontSize:13}}>
              + Add Another Business
            </button>
          </div>
        )}

        {/* Create form */}
        {showForm && (
          <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:18,padding:28}}>
            <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:20}}>
              {businesses.length > 0 ? 'New Business' : 'Create Your Business'}
            </div>
            {error && <div style={{color:'#f87171',fontSize:13,marginBottom:14,padding:'10px 14px',
              background:'rgba(248,113,113,0.1)',borderRadius:8}}>{error}</div>}

            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
              <div style={{gridColumn:'1/-1'}}>
                <label style={{fontSize:10,color:C.muted,textTransform:'uppercase',letterSpacing:1}}>Business Name *</label>
                <input value={form.name} onChange={e=>f('name',e.target.value)} style={inp} placeholder="Joe's Coffee" />
              </div>
              <div>
                <label style={{fontSize:10,color:C.muted,textTransform:'uppercase',letterSpacing:1}}>Category</label>
                <select value={form.category} onChange={e=>f('category',e.target.value)} style={inp}>
                  {CATEGORIES.map(c=><option key={c} value={c}>{c.charAt(0).toUpperCase()+c.slice(1)}</option>)}
                </select>
              </div>
              <div>
                <label style={{fontSize:10,color:C.muted,textTransform:'uppercase',letterSpacing:1}}>Email</label>
                <input value={form.email} onChange={e=>f('email',e.target.value)} style={inp} type="email" />
              </div>
              <div>
                <label style={{fontSize:10,color:C.muted,textTransform:'uppercase',letterSpacing:1}}>Phone</label>
                <input value={form.phone} onChange={e=>f('phone',e.target.value)} style={inp} />
              </div>
              <div style={{gridColumn:'1/-1'}}>
                <label style={{fontSize:10,color:C.muted,textTransform:'uppercase',letterSpacing:1}}>Address</label>
                <input value={form.address} onChange={e=>f('address',e.target.value)} style={inp} />
              </div>
              <div style={{gridColumn:'1/-1'}}>
                <label style={{fontSize:10,color:C.muted,textTransform:'uppercase',letterSpacing:1}}>Description</label>
                <textarea value={form.description} onChange={e=>f('description',e.target.value)} rows={2} style={{...inp,resize:'vertical'}} />
              </div>
              <div>
                <label style={{fontSize:10,color:C.muted,textTransform:'uppercase',letterSpacing:1}}>Website</label>
                <input value={form.website||''} onChange={e=>f('website',e.target.value)} style={inp} placeholder="https://..." />
              </div>
              <div>
                <label style={{fontSize:10,color:C.muted,textTransform:'uppercase',letterSpacing:1}}>Opening Hours</label>
                <input value={form.openingHours||''} onChange={e=>f('openingHours',e.target.value)} style={inp} placeholder="Mon–Fri 9am–6pm" />
              </div>
              <div>
                <label style={{fontSize:10,color:C.muted,textTransform:'uppercase',letterSpacing:1}}>Accent Color</label>
                <div style={{display:'flex',gap:8,alignItems:'center'}}>
                  <input type="color" value={form.accentColor||'#6366f1'} onChange={e=>f('accentColor',e.target.value)} style={{width:36,height:36,border:'none',background:'transparent',cursor:'pointer',borderRadius:8,padding:0}}/>
                  <input value={form.accentColor||''} onChange={e=>f('accentColor',e.target.value)} style={{...inp,flex:1}} placeholder="#6366f1"/>
                </div>
              </div>
              <div>
                <label style={{fontSize:10,color:C.muted,textTransform:'uppercase',letterSpacing:1}}>Latitude (for map)</label>
                <input value={form.lat||''} onChange={e=>f('lat',e.target.value)} style={inp} placeholder="27.7172" type="number" step="any"/>
              </div>
              <div>
                <label style={{fontSize:10,color:C.muted,textTransform:'uppercase',letterSpacing:1}}>Longitude (for map)</label>
                <input value={form.lng||''} onChange={e=>f('lng',e.target.value)} style={inp} placeholder="85.3240" type="number" step="any"/>
              </div>
            </div>

            {/* Modules */}
            <div style={{marginTop:20,marginBottom:20}}>
              <div style={{fontSize:12,color:C.muted,textTransform:'uppercase',letterSpacing:1.5,marginBottom:12}}>
                Enable Modules
              </div>
              {[
                ['loyalty',    '🏆 Loyalty Program',    'Points, rewards, and tiers'],
                ['attendance', '📅 Attendance Tracking', 'Check-in history and streaks'],
                ['membership', '🎫 Membership Plans',    'Paid plans and subscriptions'],
                ['products',   '🛍️ Product Catalog',    'Sell products with cart & orders'],
                ['bookings',   '📅 Appointments',        'Booking system with time slots'],
                ['storefront', '🏪 Online Storefront',   'Full e-commerce with payments'],
              ].map(([k,label,desc])=>(
                <div key={k} onClick={()=>toggleModule(k)}
                  style={{display:'flex',alignItems:'center',gap:14,padding:'12px 16px',
                    borderRadius:12,cursor:'pointer',marginBottom:8,
                    background: form.modules[k] ? `rgba(99,102,241,0.1)` : 'rgba(255,255,255,0.03)',
                    border:`1px solid ${form.modules[k] ? C.indigo+'44' : C.border}`}}>
                  <div style={{width:20,height:20,borderRadius:6,border:`2px solid ${form.modules[k]?C.indigo:C.muted}`,
                    background:form.modules[k]?C.indigo:'transparent',display:'flex',
                    alignItems:'center',justifyContent:'center',flexShrink:0,fontSize:12}}>
                    {form.modules[k]&&'✓'}
                  </div>
                  <div>
                    <div style={{fontSize:13,fontWeight:600,color:C.text}}>{label}</div>
                    <div style={{fontSize:11,color:C.muted}}>{desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <div style={{display:'flex',gap:10}}>
              {businesses.length > 0 && (
                <button onClick={()=>setShowForm(false)}
                  style={{flex:1,padding:'11px',borderRadius:10,border:`1px solid ${C.border}`,
                    background:'transparent',color:C.muted,cursor:'pointer',fontSize:13}}>
                  Cancel
                </button>
              )}
              <button onClick={save} disabled={saving}
                style={{flex:2,padding:'11px',borderRadius:10,border:'none',
                  background:`linear-gradient(135deg,${C.indigo},#4f46e5)`,
                  color:'#fff',fontWeight:700,cursor:saving?'not-allowed':'pointer',
                  fontSize:14,opacity:saving?0.7:1}}>
                {saving ? 'Creating…' : '🚀 Create Business'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}